let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6yicv")).then(() => parcelRequire('gEqF8'));